import { FornecedorVisualizacao } from "../../../components/fornecedor/visualizacao/Visualizacao";

export const VisualizacaoFornecedorPage = () => {
    return (
        <div style={{
            margin: "auto"
        }}>
            <FornecedorVisualizacao />
        </div>
    ); 
}